const parseLampiran = (value) => {
  if (!value) return [];
  if (Array.isArray(value)) return value;
  try {
    const parsed = JSON.parse(value);
    return Array.isArray(parsed) ? parsed : [];
  } catch {
    return [];
  }
};

export function buildMtShowData({ dashboardPickerMtId = "", dashboardPickerMtRow = null, opsiMT = [] } = {}) {
  const idMt = String(dashboardPickerMtId || "").trim();
  const sourceList = Array.isArray(opsiMT) ? opsiMT : [];
  const mtShowSource = sourceList.find((x) => String(x?.id_mt || "").trim() === idMt) || null;
  const row = dashboardPickerMtRow && typeof dashboardPickerMtRow === "object" ? dashboardPickerMtRow : null;
  if (!mtShowSource) return null;
  return {
    id_mt: String(row?.id_mt || mtShowSource?.id_mt || "").trim(),
    nopol: String(row?.nopol || mtShowSource?.nopol || "").trim(),
    kode_cabang: String(row?.kode_cabang_aktif || row?.kode_cabang || mtShowSource?.kode_cabang || "").trim(),
    merk: String(row?.merk || mtShowSource?.merk || "").trim(),
    kapasitas: String(row?.kapasitas || mtShowSource?.kapasitas || "").trim(),
    kategori: String(row?.kategori || mtShowSource?.kategori || "").trim(),
    status: String(row?.status || mtShowSource?.status || "").trim(),
    roda: Number(row?.roda || mtShowSource?.roda || 0),
    cadangan: Number(row?.cadangan || mtShowSource?.cadangan || 0),
    tahun_pembuatan: String(row?.tahun_pembuatan || mtShowSource?.tahun_pembuatan || "").trim(),
    kir: String(row?.kir || mtShowSource?.kir || "").trim(),
    odo_awal: Number(row?.odo_awal || mtShowSource?.odo_awal || 0),
    catatan_ban_initial: String(row?.catatan_ban_initial || mtShowSource?.catatan_ban_initial || "").trim(),
    tanggal: row?.tanggal || mtShowSource?.tanggal || null,
    user: String(row?.user || mtShowSource?.user || "").trim(),
    lampiran: parseLampiran(row?.lampiran),
    lampiran_mt_event: String(row?.lampiran_mt_event || ""),
  };
}
